<template>
  <div class="d-flex">
    <ScheduleXCalendar
      v-resize="onResize"
      :custom-components="customComponents"
      :calendar-app="calendarApp"
    >
    </ScheduleXCalendar>
    <DialogAppointment />
    <DialogVacation />
    <DialogDetails />
    <ProfilAddressAlert v-if="dialogStore.dialogYouNeedProfilesAndAddress" />
  </div>
</template>

<script lang="ts" setup>
import '@holitime/schedule-x-theme-default/dist/index.css'
import { ScheduleXCalendar } from '@holitime/schedule-x-vue'
import { calendarApp } from '@/components/calendar/calendarApp'
import { CustomComponents } from '@holitime/schedule-x-shared'
import CustomSidebarWrapper from '@/components/calendar/CustomSidebarWrapper.vue'
import { useDisplay } from 'vuetify'
import {
  useHeaderState,
  useSidebarState,
} from '@/components/calendar/calendarState'
import CustomTimeGridEvent from '@/components/calendar/CustomTimeGridEvent.vue'
import DialogVacation from '@/components/calendar/DialogVacation.vue'
import DialogAppointment from '@/components/calendar/DialogAppointment.vue'
import DialogDetails from '@/components/calendar/DialogDetails.vue'
import { onMounted, nextTick, onUnmounted, watch } from 'vue'
import { usePractitionerAppointmentStore } from '@/store/practitioner-appointment/practitionerAppointmentStore'
import { useI18n } from 'vue-i18n'
import { useRoute, onBeforeRouteLeave } from 'vue-router'
import CustomMonthGridEvent from '@/components/calendar/CustomMonthGridEvent.vue'
import createHttpClient from '@/api/httpClient'
import { ApiResponse } from '@/api/api'
const httpClient = createHttpClient()
import { useRouter } from 'vue-router'
import EventBus from '@/utils/eventBus'
import { useUserStore } from '@/store/user/userStore'
import { useAddressStore } from '@/store/address/addressStore'
import { useProfileStore } from '@/store/profile/profileStore'
import { useDialogTimeSlotStore } from '@/store/timeslot/dialogTimeSlotStore'
import { useAppointmentReasonStore } from '@/store/appointment-reason/appointementReasonStore'
import { useVacationEventStore } from '@/store/vacation/vacationEventStore'
import CustomVacationBtn from '@/components/calendar/CustomVacationBtn.vue'
import ProfilAddressAlert from '@/components/dialog/ProfilAddressAlert.vue'
import { useOnboardingStore } from '@/store/onboarding/onboardingStore'

const appointmentReasonStore = useAppointmentReasonStore()
const userStore = useUserStore()
const addressStore = useAddressStore()
const dialogStore = useDialogTimeSlotStore()
const profileStore = useProfileStore()
const vacationStore = useVacationEventStore()

onUnmounted(() => {
  dialogStore.dialogYouNeedProfilesAndAddress = false
})

const customComponents: CustomComponents = {
  // headerContentRightAppend: CustomVacationBtn as unknown as any,
  sidebar: CustomSidebarWrapper as unknown as any,
  // dateGridEvent: CustomDateGridEvent as unknown as any,
  timeGridEvent: CustomTimeGridEvent as unknown as any,
  monthGridEvent: CustomMonthGridEvent as unknown as any,
}

const { lgAndUp } = useDisplay()
const { sidebarState } = useSidebarState()

const onResize = () => {
  const calendarContainer = document.querySelector('.sx__calendar-content')
  if (!calendarContainer) return
  if (lgAndUp.value && sidebarState.value) {
    calendarContainer.classList.remove('hidden-sidebar')
  }
  if (
    lgAndUp.value &&
    calendarContainer.classList.contains('hidden-sidebar') &&
    !sidebarState.value
  ) {
    calendarContainer.classList.add('hidden-sidebar')
  }
  if (!lgAndUp.value) {
    calendarContainer.classList.remove('hidden-sidebar')
  }
}

const practitionerAppointmentStore = usePractitionerAppointmentStore()
const route = useRoute()

const headerState = useHeaderState()
const { t } = useI18n()
const router = useRouter()

EventBus.on('reInitAppointments', () => {
  practitionerAppointmentStore.initAppointments()
})

onMounted(() => {
  nextTick(() => {
    const el = document.querySelector(
      '.sx__calendar-header-content-add-time-off',
    )
    if (el) {
      el.setAttribute('style', 'display: none !important')
    }
  })

  // handleGoogleCallback()
  practitionerAppointmentStore.initAppointments()
  if (route.name === 'DashboardTimeSlot') {
    headerState.updateHeaderState(t('dashboard.menu.appointment'))
  }
  if (route.name === 'DashboardAppointment') {
    headerState.updateHeaderState(t('dashboard.menu.timeslot'))
  }

  profileStore.refreshProfiles()
  addressStore.refreshAddresses()
  dialogStore.resetDialogTimeSlotCreationProfileAddress()
  appointmentReasonStore.refreshAppointmentReasons()
})

onBeforeRouteLeave((to, from, next) => {
  const onboarding = useOnboardingStore()
  if (onboarding.hasOnboarding && !onboarding.manualProccess) {
    onboarding.onboardingAlert = true
    onboarding.leave = false

    const unwatch = watch(
      () => onboarding.leave,
      confirmed => {
        if (confirmed) {
          onboarding.leave = false
          onboarding.onboardingAlert = false
          next()
        } else {
          onboarding.onboardingAlert = false
          next(false)
        }
        unwatch()
      },
    )
  } else {
    next()
  }
})
</script>

<style lang="scss">
@import url('./styleCalendar.css');
</style>
